module.exports = ".btn-primary-outline {\r\n    background-color: transparent;\r\n    border-color: #ccc;\r\n    color: #fff!important;\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/Service/service.component.css
// module id = ./src/app/component/Service/service.component.css
// module chunks = main